import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=fe88cd80&scoped=true&"
import script from "./TableForm.vue?vue&type=script&lang=ts&"
export * from "./TableForm.vue?vue&type=script&lang=ts&"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=fe88cd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe88cd80",
  null
  
)

export default component.exports